// Header height adjuster to account top border scallop
const customHeaderHeight = () => {
    if(!window.theme.settings.enableThemeTopBorder) return;
    
    const header = document.querySelector('.site-header');
    if(!header || header.classList.contains('site-header--compress')) return;

    const findHeight = () => {
        const headerHeight = header.offsetHeight;

        document.documentElement.style.setProperty('--header-background-height', `${headerHeight}px`);

    };
    findHeight();

    const resizeObserver = new ResizeObserver(findHeight);
    resizeObserver.observe(header);

}
document.addEventListener('shopify:section:load', customHeaderHeight);
document.addEventListener('shopify:section:reorder', customHeaderHeight);
document.addEventListener('shopify:section:select', customHeaderHeight);
document.addEventListener('shopify:section:deselect', customHeaderHeight);
document.addEventListener("DOMContentLoaded", customHeaderHeight);


const activeNavLink = () => {
    const mainNavLinks = document.querySelectorAll('.site-header .menu__item');
    if(mainNavLinks.length < 1) return;
    
    mainNavLinks.forEach(mainNav => {
        const topLevelNav = mainNav.querySelector(':scope > a.navlink--toplevel');
        if(!topLevelNav) return;
        
        if(!topLevelNav.classList.contains('navlink--active-custom')) {
            const childrenLinks = mainNav.querySelectorAll('.navlink');
            const hasActiveChild = Array.from(childrenLinks).some(link => 
                link.classList.contains('navlink--active')
            );
            
            if(hasActiveChild) {
                topLevelNav.classList.add('navlink--active-custom');
            }
        }
    });
}
document.addEventListener("DOMContentLoaded", activeNavLink);

// Blog post tag filter slider
// const blogFilterSlider = () => {
//   const blogFilters = document.querySelector('.blog .blog__tags-list-custom');
//   const flkty = new Flickity(blogFilters, {
//       cellAlign: 'left',
//       contain: true,
//       pageDots: false,
//       draggable: true,
//       adaptiveHeight: false,
//       prevNextButtons: false
//     });
// }
// document.addEventListener("DOMContentLoaded", function() {
//     if (document.querySelector('.blog .blog__tags-list-custom')) {
//       blogFilterSlider();
//     }
// });
// document.addEventListener('shopify:section:load', () => {
//   if (document.querySelector('.blog .blog__tags-list-custom')) {
//     blogFilterSlider();
//   }
// });




// CODE FOR REARRANGING FILTERS
function applyFilterCustomizations() {

  // ── STEP 1: Remove " Collection" from filter titles ──────────────────────
  document.querySelectorAll('.collection__filter__title').forEach(function (btn) {
    const span = btn.querySelector('span:first-child');
    if (span && span.textContent.includes('Collection')) {
      span.textContent = span.textContent.replace(/\s*Collection\s*/g, '').trim();
    }
  });

  // ── STEP 2 & 3: Move Level1 to top, hide its title/toggle ────────────────
  const level1Filter = document.getElementById('level1');

  if (level1Filter) {
    const sidebar = level1Filter.parentElement;
    if (sidebar.firstChild !== level1Filter) {
      sidebar.insertBefore(level1Filter, sidebar.firstChild);
    }

    const title = level1Filter.querySelector('.collection__filter__title');
    if (title) title.style.display = 'none';

    // ── STEP 4: Add top padding to the ul so it doesn't get clipped ──────
    const ul = level1Filter.querySelector('ul');
    if (ul) ul.style.paddingTop = '10px';
  }
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', function () {
  applyFilterCustomizations();

  // Watch the filter sidebar for any DOM changes (AJAX re-renders)
  const sidebar = document.querySelector('.collection__filters, [data-collection-filters], #CollectionFilters')
    || document.querySelector('.collection__filter')?.parentElement;

  if (sidebar) {
    const observer = new MutationObserver(function () {
      applyFilterCustomizations();
    });
    observer.observe(sidebar, { childList: true, subtree: true });
  }
});

// Reorder blog tag select list into a custom defined order
document.addEventListener('DOMContentLoaded', function () {
  const select = document.querySelector('select.blog__tags-custom');
  if (!select) return;

  const desiredOrder = [
    'Sourdough & Baking',
    'Pickles & Ferments',
    'Kombucha',
    'Cheese & Yogurt & Butter',
    'Jam & Preserves',
    'Grains & Legumes',
    'Beer & Wine & Cider',
    'Milk & Water Kefir',
    'Sodas & Kvass',
    'Vinegars',
    'Herbal Medicine',
    'Other Fun Stuff',
  ];

  const options = Array.from(select.options);

  // Pull out any "default" option (e.g. "All", placeholder) to keep it first
  const defaultOption = options.find(opt => !desiredOrder.includes(opt.textContent.trim()));

  // Sort the remaining options by their position in desiredOrder
  // (tags not in the list will fall to the end, alphabetically)
  const sorted = options
    .filter(opt => desiredOrder.includes(opt.textContent.trim()))
    .sort((a, b) => {
      return desiredOrder.indexOf(a.textContent.trim()) - desiredOrder.indexOf(b.textContent.trim());
    });

  const unknown = options
    .filter(opt => !desiredOrder.includes(opt.textContent.trim()) && opt !== defaultOption)
    .sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim()));

  // Re-append in order: default placeholder → known tags → any unknown tags
  if (defaultOption) select.appendChild(defaultOption);
  sorted.forEach(opt => select.appendChild(opt));
  unknown.forEach(opt => select.appendChild(opt));
});



(function () {
  var monthOrder = [
    'january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'
  ];

  function sortMonthFilters() {
    var list = document.querySelector('#month ul.collection__filter-tags');
    if (!list) return;

    var items = Array.from(list.querySelectorAll('li[id^="month_"]'));
    if (items.length < 2) return;

    // Check if already in order
    var needsSort = false;
    for (var i = 1; i < items.length; i++) {
      var prevIdx = monthOrder.indexOf(items[i - 1].id.replace('month_', ''));
      var currIdx = monthOrder.indexOf(items[i].id.replace('month_', ''));
      if (prevIdx > currIdx) { needsSort = true; break; }
    }
    if (!needsSort) return;

    items.sort(function (a, b) {
      return monthOrder.indexOf(a.id.replace('month_', ''))
           - monthOrder.indexOf(b.id.replace('month_', ''));
    });

    items.forEach(function (item) { list.appendChild(item); });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortMonthFilters);
  } else {
    sortMonthFilters();
  }

  // Re-run after AJAX filter updates using a targeted MutationObserver
  var timer = null;
  function debouncedSort() {
    clearTimeout(timer);
    timer = setTimeout(sortMonthFilters, 150);
  }

  // Wait for DOM ready, then observe a stable parent
  function startObserver() {
    var target = document.getElementById('CollectionProductGrid')
              || document.getElementById('MainContent')
              || document.querySelector('[data-collection-filter]')
              || document.body;

    var observer = new MutationObserver(debouncedSort);
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();